module.exports = __webpack_public_path__ + "assets/img/100@3x.9f3804e9.png";